<template>
  <div ref="date_chart" style="width: 100%; height: 240px"></div>
</template>



<script>
export default {
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_ddp",
    },
  },
  watch: {
    timestamp() {
      if (this.action === "reload") {
        this.createGraph();
      } else {
        if (this.evt == null) {
          this.evt = new CustomEvent(this.event_name);
        }
        this.$refs.date_chart.dispatchEvent(this.evt);
      }
    },
  },
  methods: {
    createGraph() {
      am4core.useTheme(am4themes_animated);
      am4core.options.commercialLicense = true;
      am4core.options.autoDispose = true;


      // Create chart instance
      var chart = am4core.create(this.$refs.date_chart, am4charts.XYChart);

      Object.entries(this.graph_data).forEach(([key, val]) => {
        chart.data.push({
          date: new Date(this.year, parseInt(key) - 1),
          key: key,
          value: val,
        });
      });

      // Set input format for the dates
      chart.dateFormatter.inputDateFormat = "M/d/yyyy";

      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.disabled = false;

      dateAxis.renderer.minGridDistance = 10;
      // dateAxis.dateFormatter = new am4core.DateFormatter();
      // dateAxis.dateFormatter.dateFormat = "M/d/yyyy";

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = false;
      //   valueAxis.logarithmic = true;

      //   valueAxis.min = 0;
      //   valueAxis.max = 100;
      //   valueAxis.strictMinMax = false;
      valueAxis.renderer.grid.template.disabled = false;
      valueAxis.renderer.labels.template.adapter.add("text", function (text) {
        return text + "%";
      });

      // Create series
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value";
      series.dataFields.dateX = "date";
      series.tooltipText = "{value}%";
      series.tensionX = 0.8;
      series.strokeWidth = 8;

      // Drop-shaped tooltips
      //   series.tooltip.background.cornerRadius = 20;
      //   series.tooltip.background.strokeOpacity = 1;
      //   series.tooltip.pointerOrientation = "vertical";
      //   series.tooltip.label.minWidth = 40;
      //   series.tooltip.label.minHeight = 40;
      //   series.tooltip.label.textAlign = "middle";
      //   series.tooltip.label.textValign = "middle";
      series.tooltip.disabled = true;

      //   Make bullets grow on hover
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      //   bullet.label.text = "{value}%";
      bullet.circle.strokeWidth = 1;
      bullet.circle.radius = 4;
      bullet.circle.fill = am4core.color("#fff");

      //   var bullethover = bullet.states.create("hover");
      //   bullethover.properties.scale = 1.3;

      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{value}%";
      valueLabel.label.fontSize = 16;
      //   valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dy = -20;
      valueLabel.label.fill = am4core.color("black");
      valueAxis.extraMax = 0.2;

      // Make a panning cursor
      //   chart.cursor = new am4charts.XYCursor();
      //   chart.cursor.behavior = "panXY";
      //   chart.cursor.xAxis = dateAxis;
      //   chart.cursor.snapToSeries = series;

      this.$refs.date_chart.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].date = new Date(this.year, parseInt(key) - 1);
              chart.data[index].value = v;
            }
          });

          chart.invalidateRawData();
        },
        false
      );
    },
  },
  mounted() {
    this.createGraph();
  },
};
</script>
